import type { ProviderDetail } from '../../../../../js/api';
import { CredentialEntriesTab } from './CredentialEntriesTab';
import { IMMUNIZATION_SECTIONS } from './credentials';
import { ProviderDrawerMaps, providerFileName } from './providerDisplay';

/**
 * Immunizations as credential ENTRIES with a backing document (the shot record, or the
 * exemption letter for an exempt entry): one section per immunization type, TB, flu and
 * COVID-19 required. The legacy "Other Documents" rows moved to the Documents tab's Legacy
 * uploads section.
 */
export function ImmunizationsTab({
  provider,
  maps,
}: {
  provider: ProviderDetail;
  maps: ProviderDrawerMaps;
}) {
  return (
    <CredentialEntriesTab
      provider={provider}
      maps={maps}
      sections={IMMUNIZATION_SECTIONS}
      testIdPrefix="provider-immunizations"
      zipSubject={`${providerFileName(provider)} Immunization Documents`}
      emptyText="No immunizations on file."
      loadingText="Loading immunizations..."
    />
  );
}
